import React, { Component } from 'react';
import { connect } from 'react-redux';

class AddFile extends Component {
    constructor(props) {
        super(props);

        this.state = {
            errors: []
        };

        this.removeFile = this.removeFile.bind(this);
        this.getFileName = this.getFileName.bind(this);
        this.getDisplayName = this.getDisplayName.bind(this);
    }

    getFileName(filename) {
        if(filename.substring(0, 1) == "@") {
            return filename.substring(1);
        }

        return filename;
    }

    getDisplayName(filename) {
        var filename = this.getFileName(filename);
        var extension = filename.substring(filename.lastIndexOf("."));
        var filename = filename.substring(0, filename.lastIndexOf("_"));

        return filename + extension;
    }

    removeFile(e, props) {
        this.props.removeFile(e, props);
    }
    
    render() {
        return (
            <div className="row collapse upload-link upload-field-container">
                <input type = "text"  name="answer[]" id="answer" key={this.props.response.ID} defaultValue={"@" + this.getFileName(this.props.response.Answer)} className="hide upload-field" />
                <a href={"https://digitalvms.s3.ca-central-1.amazonaws.com/surveys/" + this.getFileName(this.props.response.Answer)} target="_blank" id="answers" className="button small image-modal">{this.getDisplayName(this.props.response.Answer)}</a>
                <a id = "remove-article-button" onClick={(e) => this.removeFile(e, this.props)}>
                    <i className="fa fa-times" aria-hidden="true"></i>
                </a>
            </div>
        );
    }
}


const mapStateToProps = store => ({
    userSession: store.userSession
})

export default connect(mapStateToProps,)(AddFile);